import React from "react";
import { generalIcons } from "../../utils/constants";
import { formatNumber } from "../../utils/helper";
import BeatLoaderComponent from "../loader/BeatLoaderComponent";

export default function WalletInfo({availableBalance, coinUsdValue, IsFetchingWalletInfo}) {
  return (
    <div className="relative flex items-center gap-2">
      <div className="w-10 h-10 laptop:w-[44px] laptop:h-[44px] bg-[#1A1A1A] rounded-xl flex items-center justify-center *:w-[60%] *:h-[60%]">
        {generalIcons.wallet}
      </div>
      <div className="flex flex-col justify-center gap-1 h-full">
        <div className="text-xs laptop:text-[14px] font-medium -tracking-04 text-dim/50 capitalize">
          Wallet Balance
        </div>
        {IsFetchingWalletInfo &&<BeatLoaderComponent size={15}/>}
        {!IsFetchingWalletInfo && <div className="flex items-center gap-1 text-sm laptop:text-[14px] xxl:text-xl font-semibold leading-none -tracking-1 text-white">
          {availableBalance ? formatNumber(availableBalance): "0"} $VANRY
          <div className="text-xs laptop:text-[14px] leading-none font-normal -tracking-04 text-green uppercase p-[6px] laptop:py-2 laptop:px-[10px] bg-green/10 rounded-md">
            ${coinUsdValue ? formatNumber(availableBalance * coinUsdValue) : "0"}
          </div>
        </div>}
      </div>
    </div>
  );
}
